// extracted by mini-css-extract-plugin
export default {"loading":"loading3_loading__1s86s","loading-ani":"loading3_loading-ani__1xov-"};